import { Component } from "react";
import { AlertTriangle } from "lucide-react";

// Per-receipt ErrorBoundary so one malformed receipt cannot bring down the
// entire history page. Production receipts can contain unexpected shapes
// (date as object, items as a non-array, etc.) — those rows now render as
// an error placeholder instead of crashing React.
export default class SafeReceiptCard extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("[SafeReceiptCard] Receipt failed to render", {
      receiptId: this.props.receiptId,
      error: error?.message,
      stack: info?.componentStack,
    });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          className="bg-white border border-red-200 rounded-xl p-3 sm:p-4 flex items-start gap-3"
          data-testid={`receipt-card-error-${this.props.receiptId || "unknown"}`}
        >
          <AlertTriangle className="h-4 w-4 text-red-500 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-red-800">
              Kunne ikke vise denne kvitteringen
            </p>
            <p className="text-xs text-red-600 mt-0.5">
              Dataene er ufullstendige eller har feil format. Du kan slette eller skanne den på nytt.
            </p>
            <div className="mt-2 flex items-center gap-2">
              {this.props.onDelete && (
                <button
                  onClick={() => this.props.onDelete(this.props.receiptId)}
                  className="text-xs text-red-700 hover:text-red-900 font-medium underline"
                  data-testid={`receipt-card-error-delete-${this.props.receiptId}`}
                >
                  Slett kvittering
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
